import * as React from 'react'

import Box from '@mui/material/Box'

type Props = {
  children: React.ReactNode
}

export function SidebarContent(props: Props) {
  const { children } = props

  return (
    <Box
      overflow="hidden auto"
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      py={1}
      px={2.5}
    >
      {children}
    </Box>
  )
}
